module.exports = __webpack_public_path__ + "img/FAC.ef274412.svg";